function initializeListingComponent() : void {
  const bulletListing = document.querySelectorAll<HTMLElement>('.layout-bulleted');

  if (bulletListing.length <= 0) {
    return;
  }

  initializeBulletListing(bulletListing);

}

function initializeBulletListing(bulletedWidgets: NodeListOf<HTMLElement>): void {

  bulletedWidgets.forEach(widget => {

    let list = widget.querySelector<HTMLElement>('.bullet-list');
    const showAllBtn = widget.querySelector<HTMLElement>('.show-all-btn');
    const showLessBtn = widget.querySelector<HTMLElement>('.show-less-btn');
    if (!list || !showAllBtn || !showLessBtn) {
      return;
    }

    showAllBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (showAllBtn.classList.contains('d-block')) {
        showAllBtn.classList.remove('d-block');
        showAllBtn.classList.add('d-none');
        showLessBtn.classList.remove('d-none');
        showLessBtn.classList.add('d-block');
        list.classList.remove('show-less');
        list.classList.add('animate');
        setTimeout(() => list.scrollTo({ top: 0, behavior: 'smooth'}), 750);
      }
    });

    showLessBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (showLessBtn.classList.contains('d-block')) {
        showLessBtn.classList.remove('d-block');
        showLessBtn.classList.add('d-none');
        showAllBtn.classList.remove('d-none');
        showAllBtn.classList.add('d-block');
        list.classList.add('show-less', 'animate');
        setTimeout(() => list.scrollTo({ top: 0, behavior: 'smooth'}), 750);
      }
    });

  });
}


document.addEventListener('DOMContentLoaded', () => {
  initializeListingComponent();
});
